import { Phone, MessageCircle, Mail, Instagram, Facebook, Twitter } from "lucide-react";
import { useLang } from "@/context";
import { CONTACT, waLink } from "@/i18n";
import { scrollToId } from "@/lib/scroll";

const NAV = [
    { id: "home", key: "home" },
    { id: "services", key: "services" },
    { id: "how-it-works", key: "howItWorks" },
    { id: "areas", key: "areas" },
    { id: "faqs", key: "faqs" },
    { id: "contact", key: "contact" },
];

export const Footer = () => {
    const { t } = useLang();
    return (
        <footer data-testid="site-footer" className="bg-[#2A0505] text-[#E9DAD2] pt-16 pb-24 md:pb-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-10">
                <div>
                    <div className="inline-flex items-center gap-3 bg-[#FBF7F3] rounded-2xl px-4 py-3">
                        <img src="/logo-mark.png" alt="Brighten Services crest logo" className="h-10 w-auto" loading="lazy" />
                        <span className="font-display font-black tracking-tight text-lg leading-none text-[#2A0505]">
                            BRIGHTEN
                            <span className="block text-[10px] font-semibold tracking-[0.35em] text-[#8D1717]">SERVICES</span>
                        </span>
                    </div>
                    <p className="text-sm text-[#C9B2A9] mt-5 max-w-xs leading-relaxed">{t.footer.tagline}</p>
                </div>
                <div>
                    <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C9A24B]">{t.footer.quickLinks}</p>
                    <ul className="mt-5 space-y-2.5">
                        {NAV.map((n) => (
                            <li key={n.id}>
                                <button data-testid={`footer-link-${n.key}`} onClick={() => scrollToId(n.id)} className="text-sm text-[#E9DAD2] hover:text-white transition-colors">
                                    {t.nav[n.key]}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C9A24B]">{t.footer.contactTitle}</p>
                    <ul className="mt-5 space-y-3 text-sm">
                        <li className="flex items-center gap-2.5">
                            <Phone className="w-4 h-4 text-[#C9A24B] shrink-0" />
                            <a href={`tel:${CONTACT.phone1}`} className="hover:text-white transition-colors">{CONTACT.phone1}</a>
                            <span className="text-[#8a6f66]">/</span>
                            <a href={`tel:${CONTACT.phone2}`} className="hover:text-white transition-colors">{CONTACT.phone2}</a>
                        </li>
                        <li className="flex items-center gap-2.5">
                            <MessageCircle className="w-4 h-4 text-[#C9A24B] shrink-0" />
                            <a href={waLink()} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">WhatsApp</a>
                        </li>
                        <li className="flex items-center gap-2.5">
                            <Mail className="w-4 h-4 text-[#C9A24B] shrink-0" />
                            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="hover:text-white transition-colors break-all">{CONTACT.email}</a>
                        </li>
                        <li className="flex items-center gap-2.5">
                            <Instagram className="w-4 h-4 text-[#C9A24B] shrink-0" />
                            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="hover:text-white transition-colors">Instagram</a>
                        </li>
                        <li className="flex items-center gap-2.5">
                            <Facebook className="w-4 h-4 text-[#C9A24B] shrink-0" />
                            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook-link" className="hover:text-white transition-colors">Facebook</a>
                        </li>
                        <li className="flex items-center gap-2.5">
                            <Twitter className="w-4 h-4 text-[#C9A24B] shrink-0" />
                            <a href={CONTACT.twitter} target="_blank" rel="noreferrer" data-testid="footer-twitter-link" className="hover:text-white transition-colors">Twitter</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#8a6f66]">
                <span data-testid="footer-copyright">© 2026 {t.footer.rights}</span>
                <span>{t.topbar.service} • {t.topbar.languages}</span>
            </div>
        </footer>
    );
};
